import { ArrowDownTrayIcon as DownloadIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import type { DateRangeFilter } from 'reduxLocal/slices/globalFiltersSlice';

import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import { COLLECTION_ORDERS_EXPORT_BUTTON_TEST_ID } from './constants';
import type { FiltersState } from './localState';
import { PayinOrdersExportDialog } from './PayinOrdersExportDialog';

type CreatePayinOrdersExportButtonProps = {
  filters: FiltersState;
  dateRange: DateRangeFilter;
};

export const CreatePayinOrdersExportButton = ({
  filters,
  dateRange
}: CreatePayinOrdersExportButtonProps) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <SecondaryButton
        onClick={() => setOpen(true)}
        data-testid={COLLECTION_ORDERS_EXPORT_BUTTON_TEST_ID}
        className="h-9"
      >
        <DownloadIcon className="size-4 stroke-current" />
        Export
      </SecondaryButton>
      <PayinOrdersExportDialog
        open={open}
        onClose={() => setOpen(false)}
        filters={filters}
        dateRange={dateRange}
      />
    </div>
  );
};
